export default __webpack_public_path__ + "static/media/admins.120d333b.svg";